import { combineReducers } from 'redux';
import mouseMovement from './mouseMovement';

const rootReducer = combineReducers({
  mouseMovement
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** /Users/spikelny/Desktop/projects/art/fastcash/~/eslint-loader!./reducers/rootReducer.js
 **/